module.exports = __webpack_public_path__ + "static/media/milkDrinks.7343c5f8.webp";